import { subscriptionService } from '../../services';

// initial state
const state = {
    list: [],
    status: [],
};

// getters
const getters = {};

// actions
const actions = {
    list ({ dispatch, commit }, data) {
        return subscriptionService
            .list(data)
            .then((nodes) => {
                commit('setList', nodes);

                return nodes;
            })
            .catch((error) => {
                commit('setList', []);
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    create ({ dispatch, commit }, data) {
        console.log('subscriptionStore: create');
        commit('addRequest');

        return subscriptionService
            .create(data)
            .then((nodes) => {
                commit('addSuccess');
                dispatch('alert/success', { message: 'Abonnement is toegevoegd' }, { root: true });

                return nodes;
            })
            .catch((error) => {
                commit('addFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    stop ({ dispatch, commit }, { id, data }) {
        console.log('subscriptionStore: stop', id);
        commit('updateRequest');

        return subscriptionService
            .stop(id, data)
            .then((result) => {
                console.log(result);
                commit('updateSuccess');

                dispatch('alert/success', { message: 'Abonnement is stopgezet' }, { root: true });

                return result;
            })
            .catch((error) => {
                commit('updateFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },
};

// mutations
const mutations = {
    setList (state, nodes) {
        state.list = nodes;
    },

    // add
    addRequest (state) {
        state.status = { adding: true };
    },
    addSuccess (state) {
        state.status = { added: true };
    },
    addFailure (state) {
        state.status = {};
    },

    // update
    updateRequest (state) {
        state.status = { updating: true };
    },
    updateSuccess (state) {
        state.status = { updated: true };
    },
    updateFailure (state) {
        state.status = {};
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
